import { useEffect, useState } from "react";
import {
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TextField,
  MenuItem,
  IconButton,
  Typography,
  Grid,
  Divider,
  Chip,
  Tooltip,
  Alert,
  Stack,
  useTheme,
  alpha,
  useMediaQuery,
  Card,
  CardContent,
  Select,
  InputLabel,
  FormControl,
  TablePagination,
  OutlinedInput,
  InputAdornment,
} from "@mui/material";
import { getUsers, addUser, updateUser, deleteUser, User } from "../Services/userService";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import PersonIcon from "@mui/icons-material/Person";
import BusinessIcon from "@mui/icons-material/Business";
import EmailIcon from "@mui/icons-material/Email";
import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";
import SearchIcon from "@mui/icons-material/Search";
import FilterListIcon from "@mui/icons-material/FilterList";
import axiosInstance from "../Services/axiosConfig";
import { Visibility, VisibilityOff } from '@mui/icons-material';
import LockIcon from '@mui/icons-material/Lock';
import { getUser } from "../Services/authService";
// Role Options
const roleOptions = [ "HR"];

// Password Validation Function
const isStrongPassword = (password: string) => {
  return /^(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_+])[A-Za-z\d!@#$%^&*()_+]{8,}$/.test(password);
};

const Users = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const isTablet = useMediaQuery(theme.breakpoints.down('md'));
  
  const [users, setUsers] = useState<User[]>([]);
  const [filteredUsers, setFilteredUsers] = useState<User[]>([]);
  const [companies, setCompanies] = useState<{ id: number; name: string }[]>([]);
  const [loading, setLoading] = useState(true);
  const [openDialog, setOpenDialog] = useState(false);
  const [selectedUser, setSelectedUser] = useState<User | null>(null);
  const [formData, setFormData] = useState<Partial<User>>({
    name: "",
    email: "",
    role: undefined,
    password: "",
    companyId: undefined,
  });
  const [errors, setErrors] = useState<{ [key: string]: string }>({});
  const [submitError, setSubmitError] = useState<string | null>(null);
  
  // Filter and Pagination states
  const [searchTerm, setSearchTerm] = useState("");
  const [roleFilter, setRoleFilter] = useState("All");
  const [companyFilter, setCompanyFilter] = useState("All");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [showPassword, setShowPassword] = useState(false);
  const user =getUser();
 
  useEffect(() => {
    
    const user =getUser();
    console.log("suer", user);
    fetchUsers();
    //setCompanies([{ id: user.company.Id, name: user.company.name }]);
    //fetchCompanies();
  }, []);

  // Apply filters
  useEffect(() => {
    if (users.length > 0) {
      let result = [...users];
      
      // Apply search term
      if (searchTerm) {
        const searchLower = searchTerm.toLowerCase();
        result = result.filter(
          user => 
            user.name.toLowerCase().includes(searchLower) || 
            user.email.toLowerCase().includes(searchLower)
        );
      }
      
      // Apply role filter
      if (roleFilter !== "All") {
        result = result.filter(user => user.role === roleFilter);
      }
      
      // Apply company filter
      if (companyFilter !== "All") {
        result = result.filter(user => user.company === companyFilter);
      }
      
      setFilteredUsers(result);
      setPage(0); // Reset to first page when filters change
    }
  }, [users, searchTerm, roleFilter, companyFilter]);

  const fetchUsers = async () => {
    try {
      setLoading(true);
      const data = await getUsers();
      console.log("The users:",data)
      setUsers(data);
      setFilteredUsers(data);
    } catch (error) {
      console.error("Failed to fetch users");
    } finally {
      setLoading(false);
    }
  };

/*   const fetchCompanies = async () => {
    try {
      const response = await axiosInstance.get("/companies");
      setCompanies(response.data);
    } catch (error) {
      console.error("Failed to fetch companies");
    }
  }; */

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    // Clear error for this field when user types
    if (errors[name]) {
      setErrors((prev) => {
        const newErrors = { ...prev };
        delete newErrors[name];
        return newErrors;
      });
    }
  };

  const handleCompanyChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const companyId = Number(e.target.value);
    setFormData((prev) => ({ ...prev, companyId }));
    if (errors.companyId) {
      setErrors((prev) => {
        const newErrors = { ...prev };
        delete newErrors.companyId;
        return newErrors;
      });
    }
  };

  const handleRoleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const role = e.target.value;
    setFormData((prev) => ({ ...prev, role }));
    if (errors.role) {
      setErrors((prev) => {
        const newErrors = { ...prev };
        delete newErrors.role;
        return newErrors;
      });
    }
  };

  const handleOpenDialog = (user: User | null = null) => {
    setSelectedUser(user);
    setFormData(
      user
        ? { ...user, password: "" }
        : { name: "", email: "", role: undefined, password: "", companyId: undefined }
    );
    setErrors({});
    setSubmitError(null);
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
  };

  const validateForm = () => {
    let tempErrors: { [key: string]: string } = {};
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!formData.name) tempErrors.name = "Name is required";
    if (!formData.email) {
      tempErrors.email = "Email is required";
    } else if (!emailRegex.test(formData.email)) {
      tempErrors.email = "Please enter a valid email address";
    }
    
    if (!formData.role)  formData.role= roleOptions[0];                    ///tempErrors.role = "Role is required";
    if (!formData.companyId) formData.companyId=user.company.id;                /// tempErrors.companyId = "Company is required";

    if (!selectedUser && !formData.password) {
      tempErrors.password = "Password is required";
    } else if (!selectedUser && !isStrongPassword(formData.password || "")) {
      tempErrors.password =
        "Password must be 8+ characters, include 1 uppercase, 1 number, and 1 special character.";
    }

    setErrors(tempErrors);
    return Object.keys(tempErrors).length === 0;
  };

  const handleSaveUser = async () => {
    const isValid = validateForm();
    if (!isValid) return;

    try {
      setSubmitError(null);
      if (selectedUser) {
        await updateUser(selectedUser.id, formData);
      } else {
        await addUser(formData);
      }
      fetchUsers();
      handleCloseDialog();
    } catch (error: any) {
      console.error("Failed to save user", error);
      setSubmitError(error.message || "Failed to save user. Please try again.");
    }
  };

  const handleDeleteUser = async (id: number) => {
    if (window.confirm("Are you sure you want to delete this user?")) {
      try {
        await deleteUser(id);
        fetchUsers();
      } catch (error) {
        console.error("Failed to delete user");
      }
    }
  };

  const getRoleChip = (role: string) => {
    const color = role === "Admin" ? "error" : "success";
    const icon = role === "Admin" ? <AdminPanelSettingsIcon /> : <PersonIcon />;
    console.log("role", role);
    return (
      <Chip 
        icon={icon}
        label={role} 
        color={color} 
        size="small" 
        variant="filled" 
      />
    );
  };

  // Handle pagination changes
  const handleChangePage = (event: unknown, newPage: number) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  // Get companies for filter dropdown
 /*  const getUniqueCompanies = () => {
    const uniqueCompanies = new Set(users.map(user => user.company));
    return Array.from(uniqueCompanies);
  };
 */
  // Get paginated data
  const getPaginatedData = () => {
    return filteredUsers.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);
  };
  // Add this handler function
  const handleTogglePasswordVisibility = () => {
    setShowPassword((show) => !show);
  };
  // Render filter section
  const renderFilters = () => (
    <Box sx={{ mb: 3, p: 2, bgcolor: alpha(theme.palette.primary.main, 0.05), borderRadius: 1 }}>
      <Grid container spacing={2} alignItems="center">
        <Grid item xs={12} md={4}>
          <TextField
            variant="outlined"
            fullWidth
            placeholder="Search by name or email"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon color="action" />
                </InputAdornment>
              ),
            }}
            size="small"
          />
        </Grid>
   {/*      <Grid item xs={6} md={3}>
          <FormControl fullWidth variant="outlined" size="small">
            <InputLabel id="role-filter-label">Role</InputLabel>
            <Select
              labelId="role-filter-label"
              id="role-filter"
              value={roleFilter}
              onChange={(e) => setRoleFilter(e.target.value)}
              label="Role"
              startAdornment={
                <InputAdornment position="start">
                  <AdminPanelSettingsIcon fontSize="small" color="action" />
                </InputAdornment>
              }
            >
              <MenuItem value="All">All Roles</MenuItem>
              {roleOptions.map(role => (
                <MenuItem key={role} value={role}>{role}</MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid> */}
{/*         <Grid item xs={6} md={3}>
          <FormControl fullWidth variant="outlined" size="small">
            <InputLabel id="company-filter-label">Company</InputLabel>
            <Select
              labelId="company-filter-label"
              id="company-filter"
              value={companyFilter}
              onChange={(e) => setCompanyFilter(e.target.value)}
              label="Company"
              startAdornment={
                <InputAdornment position="start">
                  <BusinessIcon fontSize="small" color="action" />
                </InputAdornment>
              }
            >
              <MenuItem value="All">All Companies</MenuItem>
              {getUniqueCompanies().map(company => (
                <MenuItem key={company} value={company}>{company}</MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid> */}
        <Grid item xs={12} md={2}>
          <Button
            variant="outlined"
            fullWidth
            onClick={() => {
              setSearchTerm("");
              setRoleFilter("All");
              setCompanyFilter("All");
            }}
            size="small"
          >
            Clear Filters
          </Button>
        </Grid>
      </Grid>
    </Box>
  );

  // Render cards for mobile view
  const renderCards = () => (
    <Grid container spacing={2} sx={{ mt: 2 }}>
      {getPaginatedData().length === 0 ? (
        <Grid item xs={12}>
          <Paper sx={{ p: 3, textAlign: 'center' }}>
            <Typography variant="body1" color="text.secondary">
              No users found matching your filters.
            </Typography>
          </Paper>
        </Grid>
      ) : (
        getPaginatedData().map((user) => (
          <Grid item xs={12} key={user.id}>
            <Card elevation={2} sx={{ overflow: 'visible' }}>
              <CardContent>
                <Grid container alignItems="center" spacing={1}>
                  <Grid item>
                    <PersonIcon color="primary" />
                  </Grid>
                  <Grid item xs>
                    <Typography variant="h6" component="div">
                      {user.name}
                    </Typography>
                  </Grid>
                  <Grid item>
                    {getRoleChip(user.role)}
                  </Grid>
                </Grid>
                
                <Divider sx={{ my: 1.5 }} />
                
                <Stack direction="row" alignItems="center" spacing={1} sx={{ mb: 0.5 }}>
                  <EmailIcon fontSize="small" color="action" />
                  <Typography variant="body2">{user.email}</Typography>
                </Stack>
                
                <Stack direction="row" alignItems="center" spacing={1}>
                  <BusinessIcon fontSize="small" color="action" />
                  <Typography variant="body2">{user.company}</Typography>
                </Stack>
                
                <Box sx={{ mt: 2, display: 'flex', justifyContent: 'flex-end' }}>
                  <Button
                    startIcon={<EditIcon />}
                    size="small"
                    onClick={() => handleOpenDialog(user)}
                    sx={{ mr: 1 }}
                  >
                    Edit
                  </Button>
                  <Button
                    startIcon={<DeleteIcon />}
                    color="error"
                    size="small"
                    onClick={() => handleDeleteUser(user.id)}
                  >
                    Delete
                  </Button>
                </Box>
              </CardContent>
            </Card>
          </Grid>
        ))
      )}
    </Grid>
  );

  // Render table for desktop/tablet view
  const renderTable = () => (
    <TableContainer component={Paper} elevation={2} sx={{ borderRadius: 1, overflow: 'auto' }}>
      <Table>
        <TableHead>
          <TableRow >
            <TableCell sx={{ fontWeight: "bold" }}>
              <Stack direction="row" spacing={1} alignItems="center">
                <PersonIcon fontSize="small" />
                <Typography fontWeight="bold">Name</Typography>
              </Stack>
            </TableCell>
            <TableCell sx={{ fontWeight: "bold" }}>
              <Stack direction="row" spacing={1} alignItems="center">
                <EmailIcon fontSize="small" />
                <Typography fontWeight="bold">Email</Typography>
              </Stack>
            </TableCell>
         {/*    {!isTablet && (
              <TableCell sx={{ fontWeight: "bold" }}>
                <Stack direction="row" spacing={1} alignItems="center">
                  <BusinessIcon fontSize="small" />
                  <Typography fontWeight="bold">Company</Typography>
                </Stack>
              </TableCell>
            )} */}
            <TableCell sx={{ fontWeight: "bold" }}>
              <Stack direction="row" spacing={1} alignItems="center">
                <AdminPanelSettingsIcon fontSize="small" />
                <Typography fontWeight="bold">Role</Typography>
              </Stack>
            </TableCell>
            <TableCell sx={{ fontWeight: "bold", width: '120px' }}>Actions</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {getPaginatedData().length === 0 ? (
            <TableRow>
              <TableCell colSpan={5} align="center" sx={{ py: 3 }}>
                <Typography variant="body1" color="textSecondary">
                  No users found matching your filters.
                </Typography>
              </TableCell>
            </TableRow>
          ) : (
            getPaginatedData().map((user) => (
              <TableRow 
                key={user.id} 
                hover 
                sx={{ 
                  '&:last-child td, &:last-child th': { border: 0 },
                  '&:hover': { backgroundColor: alpha(theme.palette.primary.main, 0.05) }
                }}
              >
                <TableCell>
                  <Typography fontWeight="medium">{user.name}</Typography>
                </TableCell>
                <TableCell>
                  <Typography>{user.email}</Typography>
                </TableCell>
       {/*          {!isTablet && (
                  <TableCell>
                    <Typography>{user.company}</Typography>
                  </TableCell>
                )} */}
                <TableCell>{getRoleChip(user.role)}</TableCell>
                <TableCell>
                  <Tooltip title="Edit User">
                    <IconButton 
                      color="primary" 
                      onClick={() => handleOpenDialog(user)}
                      size="small"
                      sx={{ mr: 1 }}
                    >
                      <EditIcon />
                    </IconButton>
                  </Tooltip>
                  <Tooltip title="Delete User">
                    <IconButton 
                      color="error" 
                      onClick={() => handleDeleteUser(user.id)}
                      size="small"
                    >
                      <DeleteIcon />
                    </IconButton>
                  </Tooltip>
                </TableCell>
              </TableRow>
            ))
          )}
        </TableBody>
      </Table>
      <Box sx={{ display: 'flex', justifyContent: 'flex-end', width: '100%' }}>
        <TablePagination
          rowsPerPageOptions={[5, 10, 25]}
          component="div"
          count={filteredUsers.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </Box>
    </TableContainer>
  );

  return (
    <Box sx={{ p: 3 }}>
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={3}>
        <Typography variant="h4" component="h1" sx={{ fontSize: { xs: '1.5rem', sm: '2rem' } }}>
          Manage Users
        </Typography>
        <Button 
          variant="contained" 
          onClick={() => handleOpenDialog()} 
          color="primary"
          startIcon={<AddCircleIcon />}
          size={isMobile ? "small" : "medium"}
        >
          {isMobile ? "Add" : "Add User"}
        </Button>
      </Box>
      
      <Divider sx={{ mb: 3 }} />
      
      {/* Filter Controls */}
      {!loading && renderFilters()}

      {loading ? (
        <Box sx={{ display: 'flex', justifyContent: 'center', py: 4 }}>
          <CircularProgress />
        </Box>
      ) : (
        <>
          {isMobile ? renderCards() : renderTable()}
          
          {/* Mobile Pagination */}
          {isMobile && (
            <Box sx={{ mt: 2 }}>
              <TablePagination
                rowsPerPageOptions={[5, 10, 25]}
                component="div"
                count={filteredUsers.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
              />
            </Box>
          )}
        </>
      )}

      <Dialog 
        open={openDialog} 
        onClose={handleCloseDialog} 
        fullWidth 
        maxWidth="sm"
        fullScreen={isMobile}
        PaperProps={{
          elevation: 2,
          sx: { borderRadius: 1 }
        }}
      >
        <DialogTitle sx={{ 
          borderBottom: `1px solid ${theme.palette.divider}`,
          py: 2
        }}>
          <Typography variant="h6">
            {selectedUser ? "Edit User" : "Add User"}
          </Typography>
        </DialogTitle>
        <DialogContent sx={{ mt: 2, pt: 2 }}>
          {submitError && (
            <Alert severity="error" sx={{ mb: 2 }}>
              {submitError}
            </Alert>
          )}
          
          <Grid container spacing={2}>
            <Grid item xs={12} paddingTop={2}> 
              <TextField 
                name="name" 
                label="Name" 
                fullWidth 
                value={formData.name || ""} 
                onChange={handleChange} 
                error={!!errors.name} 
                helperText={errors.name || ""} 
                margin="dense"
                InputProps={{ 
                  startAdornment: <PersonIcon color="action" sx={{ mr: 1 }} /> 
                }}
                variant="outlined"
              />
            </Grid>
            <Grid item xs={12}>
              <TextField 
                name="email" 
                label="Email" 
                fullWidth 
                value={formData.email || ""} 
                onChange={handleChange} 
                error={!!errors.email} 
                helperText={errors.email || ""} 
                InputProps={{ 
                  startAdornment: <EmailIcon color="action" sx={{ mr: 1 }} /> 
                }}
                variant="outlined"
              />
            </Grid>
{/*             <Grid item xs={12}>
              <TextField 
                select 
                name="role"
                label="Role" 
                fullWidth 
                value={formData.role || ""} 
                onChange={handleRoleChange} 
                error={!!errors.role} 
                helperText={errors.role || ""}
                InputProps={{ 
                  startAdornment: <AdminPanelSettingsIcon color="action" sx={{ mr: 1 }} /> 
                }}
                variant="outlined"
              >
                {roleOptions.map((role) => (
                  <MenuItem key={role} value={role}>{role}</MenuItem>
                ))}
              </TextField>
            </Grid>
            <Grid item xs={12}>
              <TextField 
                select 
                name="companyId"
                label="Company" 
                fullWidth
                value={formData.companyId || ""} 
                onChange={handleCompanyChange} 
                error={!!errors.companyId} 
                helperText={errors.companyId || ""}
                InputProps={{ 
                  startAdornment: <BusinessIcon color="action" sx={{ mr: 1 }} /> 
                }}
                variant="outlined"
              >
                {companies.map((company) => (
                  <MenuItem key={company.id} value={company.id}>{company.name}</MenuItem>
                ))}
              </TextField>
            </Grid> */}
            { (
              <Grid item xs={12}>
              <TextField
                name="password"
                label="Password"
                type={showPassword ? "text" : "password"}
                fullWidth
                required
                value={formData.password || ""}
                onChange={handleChange}
                error={!!errors.password}
                helperText={errors.password || ""}
                variant="outlined"
                autoComplete="new-password"
                inputProps={{ minLength: 6 }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <LockIcon color="action" />
                    </InputAdornment>
                  ),
                
                }}
              />
            </Grid>
            
            )}
          </Grid>
        </DialogContent>
        <DialogActions sx={{ px: 3, py: 2, borderTop: `1px solid ${theme.palette.divider}` }}>
          <Button 
            onClick={handleCloseDialog} 
            variant="outlined"
            color="inherit"
          >
            Cancel
          </Button>
          <Button 
            onClick={handleSaveUser} 
            variant="contained" 
            color="primary"
            disabled={!formData.name}
          >
            {selectedUser ? "Update" : "Save"}
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default Users;